import { render, staticRenderFns } from "./tasks-modal.vue?vue&type=template&id=3e8e9f58&scoped=true"
import script from "./tasks-modal.vue?vue&type=script&lang=ts"
export * from "./tasks-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e9f58",
  null
  
)

export default component.exports